/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Call,
  CallSettings,
  CallsListParams,
  CallsSummary,
  PaginatedCallList,
  PatchedCallSettingsRequest,
  SimulateCallRequest
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type callsListResponse200 = {
  data: PaginatedCallList
  status: 200
}
    
export type callsListResponseSuccess = (callsListResponse200) & {
  headers: Headers;
};
;

export type callsListResponse = (callsListResponseSuccess)

export const getCallsListUrl = (params?: CallsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/calls/?${stringifiedParams}` : `/api/v1/calls/`
}

export const callsList = async (params?: CallsListParams, options?: RequestInit): Promise<callsListResponse> => {
  
  return apiFetch<callsListResponse>(getCallsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCallsListQueryKey = (params?: CallsListParams,) => {
    return [
    `/api/v1/calls/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getCallsListQueryOptions = <TData = Awaited<ReturnType<typeof callsList>>, TError = unknown>(params?: CallsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof callsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCallsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof callsList>>> = ({ signal }) => callsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof callsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CallsListQueryResult = NonNullable<Awaited<ReturnType<typeof callsList>>>
export type CallsListQueryError = unknown


export function useCallsList<TData = Awaited<ReturnType<typeof callsList>>, TError = unknown>(
 params: undefined |  CallsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof callsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof callsList>>,
          TError,
          Awaited<ReturnType<typeof callsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCallsList<TData = Awaited<ReturnType<typeof callsList>>, TError = unknown>(
 params?: CallsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof callsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof callsList>>,
          TError,
          Awaited<ReturnType<typeof callsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCallsList<TData = Awaited<ReturnType<typeof callsList>>, TError = unknown>(
 params?: CallsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof callsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCallsList<TData = Awaited<ReturnType<typeof callsList>>, TError = unknown>(
 params?: CallsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof callsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCallsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type callsRetrieveResponse200 = {
  data: Call
  status: 200
}
    
export type callsRetrieveResponseSuccess = (callsRetrieveResponse200) & {
  headers: Headers;
};
;

export type callsRetrieveResponse = (callsRetrieveResponseSuccess)

export const getCallsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/calls/${id}/`
}

export const callsRetrieve = async (id: string, options?: RequestInit): Promise<callsRetrieveResponse> => {
  
  return apiFetch<callsRetrieveResponse>(getCallsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCallsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/calls/${id}/`
    ] as const;
    }

    
export const getCallsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof callsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof callsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCallsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof callsRetrieve>>> = ({ signal }) => callsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof callsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CallsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof callsRetrieve>>>
export type CallsRetrieveQueryError = unknown


export function useCallsRetrieve<TData = Awaited<ReturnType<typeof callsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof callsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof callsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof callsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCallsRetrieve<TData = Awaited<ReturnType<typeof callsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof callsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof callsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof callsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCallsRetrieve<TData = Awaited<ReturnType<typeof callsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof callsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCallsRetrieve<TData = Awaited<ReturnType<typeof callsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof callsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCallsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * « I take it » / « called back »: the person is recorded on the call.
 */
export type callsHandledCreateResponse200 = {
  data: Call
  status: 200
}
    
export type callsHandledCreateResponseSuccess = (callsHandledCreateResponse200) & {
  headers: Headers;
};
;

export type callsHandledCreateResponse = (callsHandledCreateResponseSuccess)

export const getCallsHandledCreateUrl = (id: string,) => {


  

  return `/api/v1/calls/${id}/handled/`
}

export const callsHandledCreate = async (id: string, options?: RequestInit): Promise<callsHandledCreateResponse> => {
  
  return apiFetch<callsHandledCreateResponse>(getCallsHandledCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getCallsHandledCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof callsHandledCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof callsHandledCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['callsHandledCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof callsHandledCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  callsHandledCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CallsHandledCreateMutationResult = NonNullable<Awaited<ReturnType<typeof callsHandledCreate>>>
    
    export type CallsHandledCreateMutationError = unknown

    export const useCallsHandledCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof callsHandledCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof callsHandledCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getCallsHandledCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type callsSettingsRetrieveResponse200 = {
  data: CallSettings
  status: 200
}
    
export type callsSettingsRetrieveResponseSuccess = (callsSettingsRetrieveResponse200) & {
  headers: Headers;
};
;

export type callsSettingsRetrieveResponse = (callsSettingsRetrieveResponseSuccess)

export const getCallsSettingsRetrieveUrl = () => {


  

  return `/api/v1/calls/settings/`
}

export const callsSettingsRetrieve = async ( options?: RequestInit): Promise<callsSettingsRetrieveResponse> => {
  
  return apiFetch<callsSettingsRetrieveResponse>(getCallsSettingsRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCallsSettingsRetrieveQueryKey = () => {
    return [
    `/api/v1/calls/settings/`
    ] as const;
    }

    
export const getCallsSettingsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof callsSettingsRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof callsSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCallsSettingsRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof callsSettingsRetrieve>>> = ({ signal }) => callsSettingsRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof callsSettingsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CallsSettingsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof callsSettingsRetrieve>>>
export type CallsSettingsRetrieveQueryError = unknown


export function useCallsSettingsRetrieve<TData = Awaited<ReturnType<typeof callsSettingsRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof callsSettingsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof callsSettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof callsSettingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCallsSettingsRetrieve<TData = Awaited<ReturnType<typeof callsSettingsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof callsSettingsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof callsSettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof callsSettingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCallsSettingsRetrieve<TData = Awaited<ReturnType<typeof callsSettingsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof callsSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCallsSettingsRetrieve<TData = Awaited<ReturnType<typeof callsSettingsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof callsSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCallsSettingsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type callsSettingsPartialUpdateResponse200 = {
  data: CallSettings
  status: 200
}
    
export type callsSettingsPartialUpdateResponseSuccess = (callsSettingsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type callsSettingsPartialUpdateResponse = (callsSettingsPartialUpdateResponseSuccess)

export const getCallsSettingsPartialUpdateUrl = () => {


  

  return `/api/v1/calls/settings/`
}

export const callsSettingsPartialUpdate = async (patchedCallSettingsRequest: PatchedCallSettingsRequest, options?: RequestInit): Promise<callsSettingsPartialUpdateResponse> => {
  
  return apiFetch<callsSettingsPartialUpdateResponse>(getCallsSettingsPartialUpdateUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedCallSettingsRequest,)
  }
);}




export const getCallsSettingsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof callsSettingsPartialUpdate>>, TError,{data: PatchedCallSettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof callsSettingsPartialUpdate>>, TError,{data: PatchedCallSettingsRequest}, TContext> => {

const mutationKey = ['callsSettingsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof callsSettingsPartialUpdate>>, {data: PatchedCallSettingsRequest}> = (props) => {
          const {data} = props ?? {};

          return  callsSettingsPartialUpdate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CallsSettingsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof callsSettingsPartialUpdate>>>
    export type CallsSettingsPartialUpdateMutationBody = PatchedCallSettingsRequest
    export type CallsSettingsPartialUpdateMutationError = unknown

    export const useCallsSettingsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof callsSettingsPartialUpdate>>, TError,{data: PatchedCallSettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof callsSettingsPartialUpdate>>,
        TError,
        {data: PatchedCallSettingsRequest},
        TContext
      > => {

      const mutationOptions = getCallsSettingsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Test mode only: an incoming WhatsApp call, without Meta (demo and tests).
 */
export type callsSimulateCreateResponse201 = {
  data: Call
  status: 201
}
    
export type callsSimulateCreateResponseSuccess = (callsSimulateCreateResponse201) & {
  headers: Headers;
};
;

export type callsSimulateCreateResponse = (callsSimulateCreateResponseSuccess)

export const getCallsSimulateCreateUrl = () => {


  

  return `/api/v1/calls/simulate/`
}

export const callsSimulateCreate = async (simulateCallRequest: SimulateCallRequest, options?: RequestInit): Promise<callsSimulateCreateResponse> => {
  
  return apiFetch<callsSimulateCreateResponse>(getCallsSimulateCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      simulateCallRequest,)
  }
);}




export const getCallsSimulateCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof callsSimulateCreate>>, TError,{data: SimulateCallRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof callsSimulateCreate>>, TError,{data: SimulateCallRequest}, TContext> => {

const mutationKey = ['callsSimulateCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof callsSimulateCreate>>, {data: SimulateCallRequest}> = (props) => {
          const {data} = props ?? {};

          return  callsSimulateCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CallsSimulateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof callsSimulateCreate>>>
    export type CallsSimulateCreateMutationBody = SimulateCallRequest
    export type CallsSimulateCreateMutationError = unknown

    export const useCallsSimulateCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof callsSimulateCreate>>, TError,{data: SimulateCallRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof callsSimulateCreate>>,
        TError,
        {data: SimulateCallRequest},
        TContext
      > => {

      const mutationOptions = getCallsSimulateCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Dashboard counts (Douala day) and the missed calls nobody took yet.
 */
export type callsSummaryRetrieveResponse200 = {
  data: CallsSummary
  status: 200
}
    
export type callsSummaryRetrieveResponseSuccess = (callsSummaryRetrieveResponse200) & {
  headers: Headers;
};
;

export type callsSummaryRetrieveResponse = (callsSummaryRetrieveResponseSuccess)

export const getCallsSummaryRetrieveUrl = () => {


  

  return `/api/v1/calls/summary/`
}

export const callsSummaryRetrieve = async ( options?: RequestInit): Promise<callsSummaryRetrieveResponse> => {
  
  return apiFetch<callsSummaryRetrieveResponse>(getCallsSummaryRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCallsSummaryRetrieveQueryKey = () => {
    return [
    `/api/v1/calls/summary/`
    ] as const;
    }

    
export const getCallsSummaryRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof callsSummaryRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof callsSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCallsSummaryRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof callsSummaryRetrieve>>> = ({ signal }) => callsSummaryRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof callsSummaryRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CallsSummaryRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof callsSummaryRetrieve>>>
export type CallsSummaryRetrieveQueryError = unknown


export function useCallsSummaryRetrieve<TData = Awaited<ReturnType<typeof callsSummaryRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof callsSummaryRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof callsSummaryRetrieve>>,
          TError,
          Awaited<ReturnType<typeof callsSummaryRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCallsSummaryRetrieve<TData = Awaited<ReturnType<typeof callsSummaryRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof callsSummaryRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof callsSummaryRetrieve>>,
          TError,
          Awaited<ReturnType<typeof callsSummaryRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCallsSummaryRetrieve<TData = Awaited<ReturnType<typeof callsSummaryRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof callsSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCallsSummaryRetrieve<TData = Awaited<ReturnType<typeof callsSummaryRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof callsSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCallsSummaryRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




